module.exports = __webpack_public_path__ + "img/lookbook_7_right.9ebdabb3.png";